// extracted by mini-css-extract-plugin
export default {"divWithTooltip":"components_divWithTooltip__Vo5rf","tooltiptext":"components_tooltiptext__adFI+"};